import { alpha } from '@mui/material'
import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MyAccountMiniWidgetDropdownButtonClasses,
} from '@dxp-module/themes'

const miniWidgetDropdownButtonStyles = makeStyles<
  MyAccountTheme,
  Record<string, never>,
  MyAccountMiniWidgetDropdownButtonClasses
>(
  ({ palette, shadows }) => ({
    iconButton: {
      padding: 2,
      border: `2px solid ${palette.primary.main}`,
    },
    loggedInIconButton: {
      backgroundColor: palette.primary.main,
      '& svg': {
        color: palette.common.white,
      },
    },
    loggedOutIconButton: {
      backgroundColor: palette.common.white,
      '& svg': {
        color: palette.primary.main,
      },
    },
    icon: {
      // used for svg sizing
      // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
      fontSize: 30,
    },
    iconOpened: {
      transform: 'rotate(90deg)',
    },
    iconClosed: {
      transform: 'rotate(-90deg)',
    },
    popover: {
      borderRadius: 0,
      boxShadow: shadows[2],
    },
    menu: {
      padding: 0,
    },
    menuItem: {
      '&:hover': {
        backgroundColor: alpha(palette.secondary.main, 0.15),
      },
    },
    listIcon: {
      // used for svg sizing
      // eslint-disable-next-line @dxp-module/guidance/forbidden-style-keys
      fontSize: 30,
    },
    listLabel: {},
    welcomeMessage: {
      cursor: 'default',
      color: palette.common.black,
      backgroundColor: palette.common.white,
      whiteSpace: 'break-spaces',
    },
    divider: {
      margin: '0 auto',
      width: '85%',
    },
    menuOpenIconButton: {},
    image: {
      objectFit: 'contain',
      width: '44px',
      height: '44px',
      backgroundColor: palette.common.white,
    },
  }),
  { name: 'MyAccount_MiniWidgetDropdownButton' }
)

export default miniWidgetDropdownButtonStyles
